export const apiItems = [
  {
    src: 'clipboard',
    label: 'Claims',
    description:
      'Get summary and detailed claim status and payments, coordination of benefits, submit reconsiderations and appeals with attachments, and retrieve documents.',
    id: 1,
    key: 'All-Claims-API',
    categoryId: 1,
    route: '/knowledge-base/claims-overview',
    apiCategory: ['claims'],
  },
  {
    src: 'id_card',
    label: 'Eligibility',
    description:
      'Find quick access to primary care provider (PCP) details, plan coverage, benefit details and your members ID cards.',
    id: 6,
    categoryId: 2,
    route: '/knowledge-base/eligibility-overview',
    apiCategory: ['eligibility'],
  },
  {
    src: 'id_card',
    label: 'Eligibility (Lightweight)',
    description:
      'Get to eligibility information such as including demographics, coverage attributes and basic member information.',
    id: 8,
    key: 'Eligibility-Lightweight-API',
    categoryId: 2,
    route: '/knowledge-base/eligibilitylw-overview',
    apiCategory: ['eligibility', 'eligibilitylw'],
  },

  {
    src: 'chat',
    label: 'Referrals',
    description:
      'The Referrals API provides detailed information about previous referrals and referral submissions.',
    id: 9,
    categoryId: 4,
    key: 'referrals-api',
    route: '/knowledge-base/referrals-overview',
    apiCategory: ['referrals'],
  },
  {
    src: 'clipboard',
    label: 'Claim Status (276/277) Extended X12 API',
    description:
      'Inquire about the status of a claim or respond to a request inquiry.',
    id: 1,
    key: 'Claim Status (276/277) X12',
    categoryId: 5,
    route: '/knowledge-base/claims-status-overview',
    apiCategory: ['claims', 'extended x12'],
  },
  {
    src: 'id_card',
    label: 'Eligibility and Benefits (270/271) Extended X12 API',
    description:
      'Use the Eligibility and Benefit Inquiry (270) transaction to inquire about the health care eligibility and benefits associated with a subscriber or dependent.',
    id: 12,
    key: 'Eligibility and Benefits (270/271)',
    categoryId: 5,
    route: '/knowledge-base/eligibility-benefits-overview',
    apiCategory: ['eligibility', 'extended x12'],
  },
  {
    src: 'mobile_clinic',
    label: 'Provider Demographic API',
    description:
      'Update provider demographics (add, terminate, change) directly from a practice management system or any application using HL7 FHIR format.',
    id: 13,
    key: 'Provider Demographic API',
    categoryId: 6,
    route: '/knowledge-base/provider-demographic-overview',
    apiCategory: ['provider demographic'],
  },
  {
    src: `clipboard_checked`,
    label: 'Prior Authorizations',
    description: 'Search and review prior authorization status details. ',
    id: 11,
    key: 'PriorAuth-API',
    categoryId: 7,
    route: '/knowledge-base/priorauth-overview',
    apiCategory: ['prior authorizations'],
  },
  {
    src: `cursor`,
    label: 'TrackIt',
    description:
      'These APIs are designed to facilitate efficient tracking and management of action and notifications.',
    id: 11,
    key: 'TrackIt',
    categoryId: 8,
    route: '/knowledge-base/trackit-overview',
    apiCategory: ['trackit'],
  },
  {
    src: `tooth`,
    label: 'Dental',
    description:
      'Our Dental APIs provide essential insights into patient coverage and real-time updates on claims, enhancing provider workflows and member interactions.',
    id: 12,
    key: 'Dental',
    categoryId: 9,
    route: '/knowledge-base/dental-overview',
    apiCategory: ['dental'],
  },
  {
    src: `share`,
    label: 'Member Eligibility Check',
    description:
      'The Member Eligibility Check API is designed to streamline the verification process before a member receives services.',
    id: 13,
    key: 'Member Eligibility Check',
    categoryId: 10,
    route: '/all-apis/super-connector-api/member-eligibility-check-overview',
    apiCategory: ['super connector'],
  },
  {
    src: `share`,
    label: 'Claim Precheck',
    description:
      'The Claim Precheck API validates claims before service to reduce errors, improve processing efficiency, and enhance user transparency.',
    id: 14,
    key: 'Claim Precheck Inquiry',
    categoryId: 10,
    route: '/all-apis/super-connector-api/claims-precheck-inquiry-overview',
    apiCategory: ['super connector'],
  },
  {
    src: `share`,
    label: 'Claim Actions',
    description:
      'The Claim Actions API streamlines the submission of claims, reconciliation requests, appeals, and attachments to ensure efficient post-service processing.',
    id: 15,
    key: 'Claim Actions',
    categoryId: 10,
    route: '/all-apis/super-connector-api/claims-actions-overview',
    apiCategory: ['super connector'],
  },
  {
    src: `share`,
    label: 'Benefit Check',
    description:
      'The Benefits Check API will help identify benefit details and authorization needs for specific services',
    id: 16,
    key: 'Benefit Check',
    categoryId: 10,
    route: '/all-apis/super-connector-api/benefit-check-overview',
    apiCategory: ['super connector'],
  },
  {
    src: `share`,
    label: 'Prior Auth and Referral Actions',
    description:
      'Coming soon: The Prior Auth and Referral Actions API enables flexible submission of referrals, pre-authorizations and documents before services are provided.',
    id: 17,
    key: 'Prior Auth & Referral Submission',
    categoryId: 10,

    apiCategory: ['super connector'],
    comingSoon: true,
  },
  {
    src: `share`,
    label: 'Claim Status Inquiry',
    description:
      'The Claim Status Inquiry API streamlines access to claim statuses, allowing providers to retrieve summaries, view details and initiate Recon or Appeal requests.',
    id: 18,
    key: 'Claims Inquiry',
    categoryId: 10,
    route: '/all-apis/super-connector-api/claim-status-inquiry-overview',
    apiCategory: ['super connector'],
  },
  {
    src: `share`,
    label: 'Document Search',
    description:
      'Coming soon: The Document Search API simplifies the delivery of EDI 835 files, EOBs, PRAs and supporting documents.',
    id: 19,
    key: 'Payments/Remittance',
    categoryId: 10,

    apiCategory: ['super connector'],
    comingSoon: true,
  },
];
